import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import DataTable from '../DataTable';
import RolePermissionList from '../Permission/RolePermissionList';
import { observable, toJS } from "mobx";
import Spinner from '../Spinner';
import ItemList from '../Form/ItemList';

@inject('roleStore', 'rolePermissionStore')
@observer
class RoleList extends Component {
  componentWillMount() {
    const { rolePermissionStore } = this.props;
    rolePermissionStore.fetchAllRoles();
  }

  @observable selectedRole = null;

  onSelectUser = e => {
    this.selectedRole = {
      id: e.id,
      name: e.name
    };
  };

  render() {
    const { roleStore, children, rolePermissionStore } = this.props;

    return (
      <div>
        <ItemList
          store={roleStore}
          columns={[
            { key: 'id', label: 'ID', editOnly: true, readOnly: true },
            { key: 'name', label: 'Name' },
            { key: 'description', label: 'Description' },
          ]}
          slug={'role'}
          onSelect={rolePermissionStore.validateRole('view permission') ? this.onSelectUser : null}
          resource={'role'}
          children={children}
          allowAdd
          allowEdit
          allowDelete
        />
        <br /><br />
        {this.selectedRole && !!roleStore.findById(this.selectedRole.id) && <RolePermissionList role={this.selectedRole} closeModal={() => this.selectedRole = null} />}
      </div>

    );
  }
}

export default RoleList;



// WEBPACK FOOTER //
// ./src/components/Role/RoleList.js